"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_LOCALES = exports.facilitiesMiddlewareConfig = void 0;
exports.getDefaultLocales = getDefaultLocales;
exports.handleFacilitiesLocaleRedirect = handleFacilitiesLocaleRedirect;
exports.createFacilitiesMiddleware = createFacilitiesMiddleware;
const server_1 = require("next/server");
/**
 * Middleware configuration for facilities pages
 */
exports.facilitiesMiddlewareConfig = {
    matcher: [
        /*
         * Match all facilities request paths except for the ones starting with:
         * - api (API routes)
         * - _next/static (static files)
         * - _next/image (image optimization files)
         * - favicon.ico (favicon file)
         * - 500 (to prevent redirect loops)
         */
        "/facilities/((?!api|_next/static|_next/image|favicon.ico|500).*)",
    ],
};
/**
 * Default locales for different apps
 */
exports.APP_LOCALES = {
    'oh-corp': ['en'],
    'oh-dch': ['es'],
    'oh-fl': ['en'],
    'oh-foundation': ['en'],
};
/**
 * Get default locales for a specific app
 * @param appName - The name of the app
 * @returns Array of default locales
 */
function getDefaultLocales(appName) {
    return exports.APP_LOCALES[appName] || ['en'];
}
/**
 * Handle facilities-specific locale redirects
 * @param request - The Next.js request object
 * @param appName - The name of the app
 * @returns NextResponse or null if no redirect is needed
 */
function handleFacilitiesLocaleRedirect(request, appName) {
    const url = new URL(request.url);
    const pathname = url.pathname;
    // Only handle facilities paths
    if (!pathname.startsWith('/facilities')) {
        return null;
    }
    const defaultLocales = getDefaultLocales(appName);
    const currentLocale = url.searchParams.get('locale') ||
        pathname.split('/')[1] ||
        defaultLocales[0];
    // Check if current locale is in the default locales for this app
    if (!defaultLocales.includes(currentLocale)) {
        // Redirect to the first default locale
        const newUrl = new URL(request.url);
        newUrl.pathname = pathname.replace(`/${currentLocale}`, `/${defaultLocales[0]}`);
        return server_1.NextResponse.redirect(newUrl);
    }
    return null;
}
/**
 * Create a facilities middleware function for a specific app
 * @param appName - The name of the app
 * @returns Middleware function
 */
function createFacilitiesMiddleware(appName) {
    return function middleware(request) {
        // Handle facilities-specific locale redirects
        const localeRedirect = handleFacilitiesLocaleRedirect(request, appName);
        if (localeRedirect)
            return localeRedirect;
        // Continue with normal request processing
        return server_1.NextResponse.next();
    };
}
